export default __webpack_public_path__ + "static/media/Series-9200-MP-Insertion-Remote-FAT.63e04706.png";